import {
  Card,
  Heading,
  Icon,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function UnlockPro() {
  return (
    <Card className="bg-gray-100 flex flex-col gap-5 items-start justify-between mb-4 p-5 text-start tablet:flex-row">
      <div className="flex flex-col gap-4">
        <Heading level="5" tagName="h2">
          Unlock full access
        </Heading>

        <ul className="flex flex-wrap gap-x-5 gap-y-2 justify-start max-w-[40rem]">
          <li className="flex gap-2 items-center">
            <Icon className="text-emerald-400" name="check" style="solid" />
            AI-powered solution reviews
          </li>

          <li className="flex gap-2 items-center">
            <Icon className="text-emerald-400" name="check" style="solid" />
            50+ portfolio-ready premium projects
          </li>

          <li className="flex gap-2 items-center">
            <Icon className="text-emerald-400" name="check" style="solid" />
            Professional Figma design files
          </li>

          <li className="flex gap-2 items-center">
            <Icon className="text-emerald-400" name="check" style="solid" />
            And more!
          </li>
        </ul>
      </div>

      <div className="flex flex-col gap-4 items-start tablet:items-end">
        <LinkWithButtonStyles href="/pro">Upgrade now</LinkWithButtonStyles>

        <p className="text-neutral-500 tablet:whitespace-nowrap">
          Work in a team?{' '}
          <a
            className="text-blue-500 underline hover:no-underline"
            href={process.env.NEXT_PUBLIC_TEAMS_PLATFORM_URL}
            target="_blank"
          >
            Upgrade your team to Pro
          </a>
        </p>
      </div>
    </Card>
  );
}
